const viewWrapperSelector = "[view-parent]";
const viewButtonSelector = "[view-selector]";
const viewContentSelector = "[view-data]";
const activeAttr = "data-current";

const wrappers = document.querySelectorAll(viewWrapperSelector);

if (wrappers.length > 0) {
  const viewGroups = Array.from(wrappers).map((wrapper) => ({
    wrapper,
    buttons: wrapper.querySelectorAll(viewButtonSelector),
    contents: wrapper.querySelectorAll(viewContentSelector),
  }));

  const deactivateAll = (group) => {
    group.contents.forEach((content) => {
      if (content.getAttribute(activeAttr) === "true") {
        content.setAttribute(activeAttr, "false");
      }
    });
    group.buttons.forEach((btn) => {
      if (btn.classList.contains("activated")) {
        btn.classList.remove("activated");
      }
    });
  };

  const activateView = (group, index) => {
    deactivateAll(group);
    group.contents[index]?.setAttribute(activeAttr, "true");
    group.buttons[index]?.classList.add("activated");
  };

  const handleClick = (group, btn) => {
    const index = Array.from(group.buttons).indexOf(btn);
    if (index >= 0) {
      activateView(group, index);
    }
  };

  viewGroups.forEach((group) => {
    group.buttons.forEach((btn) => {
      btn.addEventListener("click", () => handleClick(group, btn));
    });
    activateView(group, 0); // Set first view as active
  });
}
